import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn, DateTimeColumn, ExternalReceptacleLinkColumn, ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperatorCode'),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId')),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId')),
        new TextColumn('Despatch ID subclass', 'despatchMailSubClass'),
        new TextColumn('Receptacle ID subclass', 'receptacleMailSubClass'),
        new DateTimeColumn('Close Date', 'closeDate'),
      ],
    },
  ];
};
